import { Scene, PerspectiveCamera, WebGLRenderer } from "three";

let camera, scene, renderer;

function scrinit() {
    camera = new PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 10);
    camera.position.z = 5;
    scene = new Scene();
    renderer = new WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);
}

export { camera, scene, renderer, scrinit };